import {asset} from 'imba';
import url from './Banner.jpeg';
export default asset({
	url: url,
	type: 'image',
	width: 2000,
	height: 557,
	toString: function(){ return this.url;}
})